import { OrgUnitType, RollType, Avtal, Patient, ProfileType } from "@/types";
import { Kontaktorsak } from "@/store/modules/operation/kontaktorsakModule";
import { STATUS_BESOK } from "@/tabs/Besok/utils";

export type Besokstypkod = {
    id: number;
    code: string;
    displayName: string;
    description?: string | null;
    valid_from_date: any;
    valid_to_date: any;
    ordning: number;
    is_active: boolean | string;
};

export type Besokstyp = {
    id: number;
    namn: string;
    typkod: string;
    typkod_display: Besokstypkod;
    form: string;
    gruppbesok: boolean | string;
    teambesok: boolean | string;
    aktiv: boolean | string;
    ordning: number;
};

export type Besoksmall = {
    id: number;
    namn: string;
    typ: number;
    typ_display: Besokstyp;
    typkod?: string;
    roller: Array<string> | Array<RollType>;
    roller_display: Array<RollType>;
    standardtid?: number | null;
    antal_patienter?: number | null;
    aktiv: boolean | string;
    ordning: number;
};

export type Oppenvardsbesok = {
    id: string;
    besoksunderlag: string;
    besoksunderlag_display: Besoksunderlag;
    bokat_datum: string | null;
    bokad_tid: string | null;
    besokslangd: string | null;
    ankomsttidpunkt: string | null;
    besok_tidpunkt_start: string | null;
    besok_tidpunkt_slut: string | null;
    avbokning_strykning_tidpunkt: string | null;
    avbokning_strykning_orsak: string | null;
    avbokning_strykning_kommentar: string | null;
    stryk_fran_vantelista: boolean;
    avvikelse: string | null;
    status: string;
};

export type Besoksunderlag = {
    dokumentationstidpunkt: string;
    ansvarig_vardperson: string;
    godkand_for_patient: boolean;
    created_by: string;
    created_at: string;
    updated_by: string;
    updated_at: string;

    vantelistdatum: string;
    vardpersonal: ProfileType["id"][];
    vardpersonal_display: ProfileType[] | null;
    kontaktorsak: Kontaktorsak["id"] | null;
    kontaktorsak_display: Kontaktorsak | null;
    patient: Patient["id"];
    patient_display: Patient;
    avtal: Avtal["id"] | null;
    avtal_display: Avtal | null;
    mall: Besoksmall["id"];
    mall_display: Besoksmall;
    enhet: OrgUnitType["id"] | null;
    enhet_display: OrgUnitType;
    kommentar: string | null;
    status: Besoksstatus;
};

export type Besoksstatus = (typeof STATUS_BESOK)[keyof typeof STATUS_BESOK]["value"];

export const BESOKSFORM_OPTIONS = [
    {
        value: "Fysiskt",
        label: "Fysiskt",
    },
    {
        value: "Distans",
        label: "Distans",
    },
];
